import { Controller, UseFormReturn } from 'react-hook-form';
import { TextInput } from '@/schemas/sceneDataSchema';
import { TextField, FormControl } from '@mui/material';
import { encodeFieldKey } from '@/schemas/validation/ValidationSchemaGenerator';

export const GenericInput = ({
  form,
  component,
  type = 'text',
}: {
  form: UseFormReturn;
  component: Omit<TextInput, 'type'>;
  type: string;
}) => {
  return (
    <Controller
      control={form.control}
      name={encodeFieldKey(component)}
      render={({ field, fieldState: { error } }) => (
        <FormControl
          fullWidth
          error={!!error}
        >
          <TextField
            type={type}
            label={component.label || 'Please enter'}
            variant='outlined'
            fullWidth
            role='textbox'
            error={!!error}
            placeholder={component.label || 'Please enter'}
            helperText={error ? error.message : component.description}
            {...field}
            value={(field.value as string) || ''}
          />
        </FormControl>
      )}
    />
  );
};
